/* eslint-disable no-useless-escape */

const SENTRY = {
  enabled: true,
  sampleRate: 1,
  projectId: '6019558',
  publicKey: '53b87f5bbc014e9ba23dbb29a81d1949',
  // Path of the account settings related JS files
  collectionPattern: /\/[a-z0-9]{2}\/[a-z0-9]{2}\/account-settings\/{1}[^\/]+\.js$/
};

export default SENTRY;
